<template>
  <div :class="checkboxListCls">
    <h3-field
      activeCls="h3-checkbox-field"
      :tip="tip"
      :errMsg="geterrMsg"
      :label="title"
      :labelStyle="labelStyle"
      :showIcon="editable && showMode === '0'"
      :required="required"
      :readOnly="!editable"
      :layout="layout"
      @iconClick="showPopupModal"
      @contentClick="showPopupModal"
    >
      <!--平铺模式-->
      <div v-if="editable && showMode === '1'" class="checkbox-item-wrapper-plain">
        <div class="checkbox-item-wrapper" :class="itemsWrapperCls" @scroll="itemsWrapperScroll">
          <h3-checkbox-item v-for="(item, index) in getOptions" :value="item.value" :key="'item_' + index" :returnValue="selected" @onChange="checkboxChange">
            <span>{{ item.label }}</span>
          </h3-checkbox-item>
        </div>
      </div>
      <!--上滑模式 或查看模式-->
      <p class="h3-field-placeholder" v-if="getInputTextList.length == 0 && editable && showMode === '0'">{{ placeHolder }}</p>
      <div class="h3-checkbox-selected-wraper" v-if="(editable && showMode === '0') || !editable">
        <div class="selected-item" v-for="(selectedItem, i) in getInputTextList" :key="i">{{ selectedItem }}</div>
      </div>
    </h3-field>
    <h3-modal
      class="h3-checkbox-picker"
      type="popup"
      popupDirection="up"
      :class="[wrapClassName]"
      :show.sync="popupModalShow"
      :appendToBody="true"
      @on-show="showModel"
      @on-hide="hide"
      v-if="editable && !readonly"
    >
      <h3-list :hasHeader="true" :bodyStyle="{ 'max-height': `${contentBodyHeight}px` }">
        <template slot="header">
          <div class="h3-checkbox-header-cancel" @click="onCancel">
            {{ cancelText }}
          </div>
          <div class="h3-checkbox-header-clear" @click="onClear">
            {{ clearText }}
          </div>
          <div class="h3-checkbox-header-right" @click="hidePopupModal">
            {{ `${okText}(${value.length})` }}
          </div>
          <div class="h3-checkbox-header-search" v-if="showHeaderSearch" @click="showHeaderSearchHandler">
            <h3-icon type="search"></h3-icon>
          </div>
        </template>
        <template v-if="getOptions.filter((item) => item.label != '').length">
          <div class="h3-checkbox-search" v-if="showSearch">
            <h3-search-bar ref="search" placeholder="搜索" v-model="seatchKey" :onChange="searchChange" :onClear="searchClear" :onCancel="searchCancel" :onFocus="searchFocus" :onBlur="searchBlur">
            </h3-search-bar>
          </div>
          <div class="h3-checkbox-content" :style="`max-height: ${showSearch ? contentBodyHeight - 44 : contentBodyHeight}px `">
            <!--    <div ref="listItem" class="h3-list-item h3-checkbox-item h3-list-item-middle" @click.stop="toogleSelecteAll">
              <div class="h3-list-item-content">
                <div class="h3-list-thumb">
                  <label class="h3-checkbox-wrapper" warplabel="true">
                    <span class="h3-checkbox" :class="getIsSelectedAll ? 'h3-checkbox-checked' : ''">
                      <input id="item_0" type="checkbox" class="h3-checkbox-input" :value="checkAllText" />
                      <span class="h3-checkbox-inner"></span>
                    </span>
                  </label>
                </div>
                <div class="h3-list-line h3-list-line-not">
                  <div class="h3-list-content">
                    <span>{{ checkAllText }}</span>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- {{ getOptions }} 已选 {{ selected }} -->
            <!-- .filter((item) => item.label != '') -->
            <h3-checkbox-item v-for="(item, index) in getOptions.filter((item) => item.label != '')" :value="item.value" :key="'item_0_' + index" :returnValue="selected" @onChange="checkboxChange">
              <span>{{ item.label }}</span>
            </h3-checkbox-item>
          </div>
        </template>
        <div class="h3-checkbox-select-empty" v-else>
          {{ notFoundText }}
        </div>
      </h3-list>
    </h3-modal>
    <!-- header search modal -->
    <h3-modal
      class="h3-checkbox-header-search-pick"
      type="popup"
      popup-direction="right"
      popup-scale="100"
      mask-closable
      :append-to-body="true"
      :show.sync="showHeaderSearchModal"
      @on-hide="hideHeaderSearchModal"
    >
      <h3-list has-header has-footer style="max-height: 100vh">
        <template slot="header">
          <h3-search-bar class="header-search-bar" placeholder="搜索" v-model="headerSearchKey" round show-cancel-button :onChange="headerSearchChange" :onCancel="headerSearchCancel"> </h3-search-bar>
        </template>
        <div class="header-search-count-wrapper">
          搜索结果：共<span class="header-search-count">{{ headerSearchOptions.length }}</span
          >条
        </div>
        <div class="h3-checkbox-content" v-if="headerSearchOptions.length">
          <h3-checkbox-item v-for="item in headerSearchOptions" :value="item.value" :key="'item_search_0_' + item.value" :returnValue="selected" @onChange="checkboxChange">
            <span>{{ item.label }}</span>
          </h3-checkbox-item>
        </div>
        <div v-else class="header-search-empty">
          <span v-if="headerSearchKey">未搜索到 “{{ headerSearchKey }}” <span class="add-new-opts" @click="addCustomeOpts">立即添加</span></span>
          <span v-else>请输入关键字搜索</span>
        </div>
        <template slot="footer">
          <div class="header-search-footer">
            <div>
              已选择：<span class="header-search-selected-count">{{ headerSearchSelectedCount }}</span>
            </div>
            <h3-button type="primary" inline size="small" @click="headerSearchConfirm">确定</h3-button>
          </div>
        </template>
      </h3-list>
    </h3-modal>
  </div>
</template>
<script>
import cx from "classnames";
import { H3List, H3Field, H3Modal, H3SearchBar } from "h3-mobile-vue";
import h3CheckboxItem from "./h3-checkbox-item"; // [除了这个在当前文件夹的组件，其他都是H3的npm包]
// import h3Button from '../h3-button/';
import h3Button from "h3-mobile-vue/lib/h3-button.js";
// import {H3Icon} from "h3-mobile-vue"; // 直接引入npm包无法显示
import H3Icon from "h3-mobile-vue/lib/h3-icon.js"; // 需要指向npm包内具体组件
import touch from "../../directives/touch";

const prefixCls = "h3-checkbox-list";
export default {
  name: "h3-checkbox-list",
  components: {
    H3List,
    H3Modal,
    h3CheckboxItem,
    h3Button,
    H3Field,
    H3SearchBar,
    H3Icon,
  },
  directives: {
    touch,
  },
  props: {
    showMode: {
      type: String,
      validator(val) {
        if (val === "1" || val === "0") {
          // 1: 平铺显示 0: 上滑显示 2:上滑
          return true;
        }
        return false;
      },
    },
    options: {
      type: Array,
      default: () => [],
    },
    title: String,
    defaultValue: Array,
    value: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    readonly: Boolean,
    onChange: Function,
    tip: {
      type: String,
      default: "",
    },
    errMsg: {
      type: String,
      default: "",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    clearText: {
      type: String,
      default: "清空",
    },
    okText: {
      type: String,
      default: "确定",
    },
    checkAllText: {
      type: String,
      default: "全选",
    },
    placeHolder: {
      type: String,
      default: "请选择多选",
    },
    show: Boolean,
    // 没有数据项时显示的文本
    notFoundText: {
      type: String,
      default: "暂无选项",
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    // 因UI交互有差异，故新增了headerSearch
    showHeaderSearch: {
      type: Boolean,
      default: false,
    },
    contentBodyHeight: {
      type: Number,
      default: 437,
    },
    labelStyle: {
      type: Object,
      default: () => {},
    },
    wrapClassName: {
      type: String,
      default: "",
    },
    layout: {
      type: String,
      default: "h",
      validator: function (value) {
        return ["h", "v"].includes(value);
      },
    },
  },
  data() {
    return {
      popupModalShow: false,
      selected: this.value || this.defaultValue || [],
      preCheckboxValue: [],
      itemsWrapperCls: "",
      selectedObj: [],
      currentScrollTop: 0,
      seatchKey: "",

      // header search
      showHeaderSearchModal: false,
      headerSearchKey: "",
      headerSearchOptions: [],
    };
  },
  created() {
    // const arr = localStorage.getItem('preCheckboxValue');
    // const preCheckboxValue = arr ? JSON.parse(arr) : [];
    // this.value = preCheckboxValue;
  },
  mounted() {
    this.popupModalShow = this.show;
  },
  methods: {
    // 添加一个自定义输入选项
    addCustomeOpts() {
      this.checkboxChange([this.headerSearchKey]);
      this.headerSearchConfirm();
    },
    showModel() {
      this.$emit("onShow");
    },
    hide() {
      this.$emit("onHide");
    },
    hidePopupModal() {
      this.popupModalShow = false;
      this.$emit("update:show", false);
    },
    showPopupModal() {
      if (this.showMode === "1") return;
      const preCheckboxValue = this.value;
      localStorage.setItem("preCheckboxValue", JSON.stringify(preCheckboxValue));
      this.popupModalShow = true;
      this.$emit("update:show", true);
      this.$nextTick(() => {
        if (this.$refs.listItem) {
          this.$refs.listItem.parentElement.scrollTop = this.currentScrollTop;
        }
      });
    },
    checkboxChange(val) {
      if (this.onChange) {
        this.onChange(val);
      }
      this.$emit("onChange", val);
    },
    onClickClear() {
      this.hidePopupModal();
      const preCheckboxValue = JSON.parse(localStorage.getItem("preCheckboxValue"));
      this.$emit("input", preCheckboxValue);
    },
    onClear() {
      this.$emit("on-clear");
      this.$emit("input", []);
      this.hidePopupModal();
    },
    onCancel() {
      this.hidePopupModal();
      const preCheckboxValue = JSON.parse(localStorage.getItem("preCheckboxValue"));
      this.$emit("input", preCheckboxValue);
    },
    itemsWrapperScroll(event) {
      this.itemsWrapperCls = "checkbox-item-wrapper-scroll";
      this.$emit("onScroll", event);
    },
    toogleSelecteAll() {
      if (!this.getIsSelectedAll) {
        const val = this.options.map((item) => {
          const isObject = Object.prototype.toString.call(item).toLowerCase() === "[object object]";
          if (isObject) {
            return item.value;
          }
          return item;
        });
        this.$emit("input", val);
        if (this.onChange) {
          this.onChange(val);
        }
        this.$emit("onChange", val);
      } else {
        const val = [];
        this.$emit("input", val);
      }
    },
    checkArrsEqual(arr1, arr2) {
      // arr1 已选序列 arr2 传入的oppinion 序列
      if (arr1.length !== arr2.length) {
        return false;
      }
      if (arr1 instanceof Array && arr2 instanceof Array) {
        const newArr1 = arr1.sort();
        const newArr2 = arr2.sort();
        for (let i = 0; i < newArr1.length; i += 1) {
          const isObject = Object.prototype.toString.call(i).toLowerCase() === "[object object]";
          const setObject = !!newArr2[i].value && newArr1[i] === newArr2[i].value;
          if (newArr1[i] !== newArr2[i] && !isObject) {
            return false;
          }
          if (isObject && !setObject) {
            return false;
          }
        }
        return true;
      }
      return true;
    },
    searchChange(val) {
      this.$emit("searchChange", val);
    },
    searchFocus(e) {},
    searchClear() {
      this.$emit("searchChange", "");
    },
    searchBlur(e) {},
    searchCancel(e) {
      this.$emit("searchChange", "");
    },
    showHeaderSearchHandler() {
      this.hidePopupModal();
      this.showHeaderSearchModal = true;
    },
    headerSearchChange(key) {
      if (key) {
        this.headerSearchOptions = this.getOptions.filter((item) => {
          return item.label && item.label.indexOf(key) !== -1;
        });
      } else {
        this.headerSearchOptions = [];
      }
    },
    headerSearchCancel() {
      this.showHeaderSearchModal = false;
    },
    headerSearchConfirm() {
      this.showHeaderSearchModal = false;
    },
    headerSearchClean() {
      this.headerSearchKey = "";
      this.headerSearchOptions = [];
    },
    hideHeaderSearchModal() {
      this.headerSearchClean();
    },
  },
  computed: {
    getOptions() {
      const ops = [];
      if (Array.isArray(this.options)) {
        this.options.forEach((value) => {
          const isObject = Object.prototype.toString.call(value).toLowerCase() === "[object object]";
          if (isObject) {
            ops.push(value);
          } else {
            const newOption = {
              value,
              label: value,
            };
            ops.push(newOption);
          }
        });
      }
      return ops;
    },
    getIsSelectedAll() {
      return this.options.length === this.value.length;
    },
    getInputTextList() {
      return this.value.map((val) => {
        const tmpItem = this.getOptions.find((item) => (item instanceof Object ? item.value === val : item === value));
        return tmpItem instanceof Object ? tmpItem.label : tmpItem || val;
      });
    },
    geterrMsg() {
      // 查看模式 不显示错误信息
      if (this.editable && !this.readonly) {
        return this.errMsg;
      }
      return "";
    },
    checkboxListCls() {
      return cx(prefixCls, `${prefixCls}-${this.showMode}`, {
        [`${prefixCls}-view`]: !this.editable || this.readonly,
      });
    },
    headerSearchSelectedCount() {
      let count = 0;
      this.headerSearchOptions.forEach((item) => {
        if (
          this.selected.some((val) => {
            return val === item.value;
          })
        ) {
          count++;
        }
      });
      return count;
    },
  },
  watch: {
    value(val) {
      this.selected = val;
      // this.$nextTick(() => {
      // console.log(val);
      // const selectAll = this.checkArrsEqual(this.selected, this.options)
      // this.isSelectedAll = selectAll
      // });
    },
    show(val) {
      this.popupModalShow = val;
    },
    popupModalShow(val) {
      if (!val) {
        if (this.showSearch) {
          this.seatchKey = "";
          this.$refs.search.cancel();
        }
        this.currentScrollTop = this.$refs.listItem.parentElement.scrollTop || 0;
      } else if (this.value.length === 0) {
        this.currentScrollTop = 0;
      }
    },
  },
};
</script>

<style lang="less">
@import "./style/index.less";
.add-new-opts {
  color: #1890ff;
  text-decoration: underline;
}
</style>